module.exports = __webpack_public_path__ + "media/images/qr-wb2-5d0afb1596d954eaec387bd6ef0ad881.png";